import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-six', 'ClockSix', [["path",{"d":"M12 6v10.5m9-4.5a9 9 0 1 1-18 0 9 9 0 0 1 18 0","key":"svg-0"}]]);